/**
 *  @class
 *  @function CartRemove
 */
if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    connectedCallback() {
      this._onClick = this.onClickHandler.bind(this);
      this._onKeydown = this.onKeydownHandler.bind(this);
      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKeydown);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKeydown);
    }
    onKeydownHandler(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.onClickHandler(event);
      }
    }
    onClickHandler(event) {
      event.preventDefault();
      const index = this.dataset.index;
      const cartDrawer = this.closest('cart-drawer');
      if (cartDrawer) {
        cartDrawer.updateQuantity(index, '0');
      } else {
        document.dispatchEvent(new CustomEvent('cart:remove', { detail: { index } }));
      }
    }
  }
  customElements.define('cart-remove', CartRemove);
}
